import React from 'react';
import bg from 'assets/images/background.png';
// import make from 'assets/images/powered-by.svg';
import dictLogo from 'assets/images/dict.png';
// import bagongPinasLogo from 'assets/images/bagong-pinas.png';
import logo from 'assets/images/efps-logo.svg';
import Login from './Login';

function LoginPage() {
  return (
    <div
      className="h-full flex flex-col bg-gray-100"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover', // Ensures the background covers the full area responsively
        backgroundPosition: 'center', // Centers the background image
      }}
    >
      <div className="w-full max-w-xl m-auto relative">
        <div className="m-auto w-full p-14 rounded-none bg-transparent md:bg-white shadow-none md:shadow-primary-xl relative z-20" style={{borderRadius: "8px"}}>
          <img src={logo} className="h-10 mb-10" alt="App" />
          <div className="pb-6">
            <div className="text-xl font-semibold">Login to your account</div>
          </div>
          <Login />
        </div>
        <div className="text-center mt-16">
          <p className="text-black text-sm mb-4">Developed by</p>
          <div className="flex justify-center space-x-8">
            <img src={dictLogo} className="h-16" alt="Brand" />
            {/* <img
              src={bagongPinasLogo}
              className="h-16 -translate-y-1"
              alt="Brand"
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

LoginPage.propTypes = {};

export default LoginPage;
